/**
 * Created by toomasp on 29.10.2015.
 */
"use strict";
export default ['debug', (dbg) => {
    class ScriptDirective {
        restrict = 'E';
        scope = false;

        link(scope, element, attrs) {
            if (attrs.src)return;

            try {
                //new Function(element.text())();
                dbg.log(element.text());
                eval(element.text());
            } catch (e) {
                dbg.error(e);
            }
        }
    }
    return new ScriptDirective()
}];


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/decorator/script.directive.js